import { Transform } from "class-transformer";

export class ReportTechnicianProductivityDto {
  id: string;
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  fullName: string;
  operativeUnitId: string;
  operativeUnitCode: string;
  operativeUnitName: string;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  theoreticalMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  absenceMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  availableMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  validatedWorkMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  validatedTravelMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  validatedPaidMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  correctedChargeableMinutes: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  occupancyPercentage: number;

  @Transform(({ value }) => (value != null ? Number(value) : 0))
  chargeabilityPercentage: number;
}
